import React from 'react';
import { Plus } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

interface NewJobButtonProps {
  onClick: () => void;
}

const NewJobButton = ({ onClick }: NewJobButtonProps) => {
  const { t } = useLanguage();
  
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
    >
      <Plus className="w-4 h-4" />
      <span>{t('dashboard.newJob')}</span>
    </button>
  );
};

export default NewJobButton;